<template>
    <v-container grid-list-lg>
        <v-layout row wrap>
            <v-flex xs12 sm6 offset-sm3 md4 offset-md4>
                <v-img src="/piguet.svg" />
            </v-flex>
            <v-flex xs12 sm6 offset-sm3 md4 offset-md4>
                <pad-login @login="login()" />
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import PadLogin from '@/components/PadLogin'

export default {
    components: { PadLogin },
    methods: {
        login() {
            if (this.$route.query.p) {
                return this.$router.push({ path: this.$route.query.p })
            }
            this.$router.push({ name: 'lots' })
        }
    }
}
</script>
